import { useGetPowerBiTokenForReport } from 'api/generated/power-bi-controller/power-bi-controller';

/**
 * Thin wrapper so presentational code never imports Orval-generated hooks directly
 * (see the frontend code-guidelines rule / Orval integrator boundary).
 */
export const usePowerBiTokenMutation = useGetPowerBiTokenForReport;
